import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as RiskAPI from '../../../API/RiskAPI'
import { immer } from 'zustand/middleware/immer'
import { getIssueSearchHistory } from 'src/API/IssueApi'

const initialState = {

    riskDetails: {},
    riskDetailsLoading: false,
    tableBodyData: [],

    // View History
    HistoryViewDetails: [],
    HistoryViewDetailsLoading: false,

    // Risk Dispute
    RiskDisputeData: [],
    RiskDisputeDataLoading: false,

    // Risk Dispute
    RiskDetailsById: {},
    RiskDetailsByIdLoading: false,

    // create Risk
    createRiskData: null,
    createRiskDataLoading: false,

    // create Risk
    riskInitialCount: null,
    riskInitialCountLoading: false,

    // create Risk
    riskAnalyzCount: null,
    riskAnalyzCountLoading: false,

    // create Risk
    riskApprovalCount: null,
    riskApprovalCountLoading: false,

    // create Risk
    riskMonitoringCount: null,
    riskMonitoringCountLoading: false,

    // create Risk
    createRiskAnalysis: null,
    createRiskAnalysisLoading: false,
    // get non-compliance
    getNonComplianceData: [],
    getNonComplianceLoading: false,
    // get risk history
    getRiskHistoryData: [],
    getRiskHistoryFilterData: [],
    historyFilterPayload: {},
    getRiskPeriodicityData: []
}

const RiskStore = create(devtools(immer((set, get) => ({
    ...initialState,
    getRiskHistory: async (riskId, orgId) => {
        set({ riskDetailsLoading: true })
        try {
            const response = await RiskAPI.getRiskHistory(riskId, orgId)
            set({ riskDetailsLoading: false, getRiskHistoryData: response.data })
        } catch (error) {
            set({ riskDetailsLoading: false, getRiskHistoryData: [] })
        }
    },
    getRiskPeriodicity: async (riskId, loginId, orgId) => {
        set({ riskDetailsLoading: true })
        try {
            const response = await RiskAPI.getRiskPeriodicity(riskId, loginId, orgId)
            set({ riskDetailsLoading: false, getRiskPeriodicityData: response.data })
        } catch (error) {
            set({ riskDetailsLoading: false, getRiskPeriodicityData: [] })
        }
    },
    getRiskHistoryFilter: async (loginId, filter) => {
        set({ riskDetailsLoading: true, historyFilterPayload: filter })
        try {
            const response = await RiskAPI.getRiskSearchHistory(loginId, filter)
            set({ riskDetailsLoading: false, getRiskHistoryFilterData: response.data })
        } catch (error) {
            set({ riskDetailsLoading: false, getRiskHistoryFilterData: [] })
        }
    },
    getIssueHistoryFilter: async (loginId, filter) => {
        set({ riskDetailsLoading: true, historyFilterPayload: filter })
        try {
            const response = await getIssueSearchHistory(loginId, filter)
            set({ riskDetailsLoading: false, getRiskHistoryFilterData: response.data })
        } catch (error) {
            set({ riskDetailsLoading: false, getRiskHistoryFilterData: [] })
        }
    },
    clearHistoryFilter: () => {
        set({ getRiskHistoryFilterData: [] })
    },
    clearRiskFilterData: () => {
        set({ getRiskHistoryFilterData: [] })
    },
    getRiskDetails: async (pageNumber, pageSize, type, stage, loginId) => {
        set({ riskDetailsLoading: true })
        let dataKey = ''
        switch (stage) {
        case 1:
            dataKey = 'riskInitialCount'
            break
        case 2:
            dataKey = 'riskApprovalCount'
            break
        case 3:
            dataKey = 'riskAnalyzCount'
            break
        case 4:
            dataKey = 'riskMonitoringCount'
            break
        default:
            dataKey = 'riskInitialCount' // or handle default case accordingly
            break
        }
        try {
            const response = await RiskAPI.getRiskDetails(pageNumber, pageSize, type, stage, loginId)
            set({ riskDetailsLoading: false, riskDetails: response.data, [dataKey]: response.data?.length, tableBodyData: response.data })
        } catch (error) {
            set({ riskDetailsLoading: false, riskDetails: [], tableBodyData: [] })
        }
    },

    getRiskDetailsCount: async (pageNumber, pageSize, type, stage, loginId) => {
        set({ riskInitialCountLoading: true })
        let dataKey = ''
        switch (stage) {
        case 1:
            dataKey = 'riskInitialCount'
            break
        case 2:
            dataKey = 'riskApprovalCount'
            break
        case 3:
            dataKey = 'riskAnalyzCount'
            break
        case 4:
            dataKey = 'riskMonitoringCount'
            break
        default:
            dataKey = 'riskInitialCount' // or handle default case accordingly
            break
        }
        try {
            const response = await RiskAPI.getRiskDetails(pageNumber, pageSize, type, stage, loginId)
            if (response.data) {
                set({ riskInitialCountLoading: false, [dataKey]: response.data?.length > 0 ? response.data[0].total : 0 })
            } else {
                set({ riskInitialCountLoading: false })
            }
        } catch (error) {
            set({ riskInitialCountLoading: false })
        }
    },

    getRiskViewHistory: async (pageNumber, pageSize, loginId) => {
        set({ HistoryViewDetailsLoading: true })
        try {
            const response = await RiskAPI.getRiskViewHistory(pageNumber, pageSize, loginId)
            if (response.data) {
                set({ HistoryViewDetailsLoading: false, HistoryViewDetails: response.data?.map((data) => { return { ...data, id: data?.contextId } }) })
            } else {
                set({ HistoryViewDetailsLoading: false })
            }
        } catch (error) {
            set({ HistoryViewDetailsLoading: false })
        }
    },

    getRiskDispute: async (pageNumber, pageSize, loginId) => {
        set({ RiskDisputeDataLoading: true })
        try {
            const response = await RiskAPI.getRiskDispute(pageNumber, pageSize, loginId)
            if (response.data) {
                set({ RiskDisputeDataLoading: false, RiskDisputeData: response.data?.map((data) => { return { ...data, id: data?.contextId } }) })
            } else {
                set({ RiskDisputeDataLoading: false })
            }
        } catch (error) {
            set({ RiskDisputeDataLoading: false })
        }
    },

    getRidkDetailsById: async (riskId, loginId) => {
        set({ RiskDetailsByIdLoading: true })
        try {
            const response = await RiskAPI.getRidkDetailsById(riskId, loginId)
            if (response.data) {
                set({ RiskDetailsByIdLoading: false, RiskDetailsById: response.data })
            } else {
                set({ RiskDetailsByIdLoading: false })
            }
        } catch (error) {
            set({ RiskDetailsByIdLoading: false })
        }
    },

    CreateRisk: async (loginId, data) => {
        set({ ...initialState, createRiskDataLoading: true })
        try {
            const response = await RiskAPI.createRisk(loginId, data)
            if (response.data) {
                set({ ...initialState, createRiskDataLoading: false, createRiskData: response?.data })
                // setTimeout(() => {
                //     set({ ...initialState, createRiskData: null })
                // }, 1000)
                return response
            } else {
                set({ ...initialState, createRiskDataLoading: false })
                return response
            }
        } catch (err) {
            set({ ...initialState, createRiskDataLoading: false })
        }
    },

    CreateRiskAnalysis: async (data) => {
        set({ ...initialState, createRiskAnalysisLoading: true })
        try {
            const response = await RiskAPI.createRiskAnalysis(data)
            if (response.data) {
                set({ ...initialState, createRiskAnalysisLoading: false, createRiskAnalysis: response?.data })
                // setTimeout(() => {
                //     set({ ...initialState, createRiskAnalysis: null })
                // }, 1000)
                return response
            } else {
                set({ ...initialState, createRiskAnalysisLoading: false })
            }
        } catch (err) {
            set({ ...initialState, createRiskAnalysisLoading: false })
        }
    },

    getNonCompliance: async (orgId, userId) => {
        set({ ...initialState, getNonComplianceLoading: true })
        try {
            const response = await RiskAPI.getNonCompliance(orgId, userId)
            if (response.data) {
                set({ ...initialState, getNonComplianceLoading: false, getNonComplianceData: response?.data })
                // setTimeout(() => {
                //     set({ ...initialState, getNonComplianceData: null })
                // }, 1000)
                return response
            } else {
                set({ ...initialState, getNonComplianceLoading: false })
            }
        } catch (err) {
            set({ ...initialState, getNonComplianceLoading: false })
        }
    }

}))))

export const useRiskStore = RiskStore
